import React, {useState} from "react";
import parse from "html-react-parser";
import {Plus, Close} from "./icons";
import {GatsbyImage, getImage} from "gatsby-plugin-image";
import Link from "../utils/link";
import Fade from "react-reveal/Fade";

const TeamArchive = ({title, team}) => {
  const [popup, setPopup] = useState(false);
  const [profile, setProfile] = useState(null)

  const toggle = (item) => {
    setPopup(true)
    setProfile(item)
  }

  return (
    <>
      <section className='team-archive'>
       <Fade bottm distance='40px'>
         <div className='team-archive__inner'>
           {title && <h2>{parse(title)}</h2>}

           <div className='team-archive__items'>
             {
               team?.length > 0 && team.map((el, i) => (
                 <div onClick={() => toggle(el)} key={i} className='team-archive__item'>
                   <button><Plus/></button>
                   {el.featuredImage?.node.localFile &&
                     <GatsbyImage loading='lazy' image={getImage(el.featuredImage?.node.localFile)} alt={el.title}/>}
                   {el.title && <h3>{el.title}</h3>}
                   {el.acf.position && <span>{el.acf.position}</span>}
                 </div>
               ))
             }
           </div>
         </div>
       </Fade>
      </section>
      <div className={`team-archive__popup ${popup ? 'active' : ''}`}>
        <div className='team-archive__popup-bg' onClick={() => setPopup(false)}></div>
        <div className='team-archive__popup-inner'>
          <div className='team-archive__popup-wrapper'>
            <button onClick={() => setPopup(false)}><Close/></button>
            <div className='team-archive__popup-image'>
              <GatsbyImage loading='lazy' image={getImage(profile?.featuredImage?.node.localFile)}
                           alt={profile?.title}/>
            </div>

            <div className='team-archive__popup-content'>
              {profile?.title && <h3>{profile?.title}</h3>}
              {profile?.acf?.position && <span>{profile?.acf?.position}</span>}
              {profile?.acf?.meetingLink && <Link to={profile?.acf?.meetingLink} className='btn btn--green'>Book a Meeting</Link>}
              {profile?.content && parse(profile?.content)}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default TeamArchive